import React from 'react'
import styled from 'styled-components'
import { useTheme, YDivider } from 'irmlib/styles'
import ReportsCard from './Cards/Reports'

import { Cards } from './Cards/Cards'

const middleVerticalSpace = '36px'

const LandingPageContainer = styled.div`
  overflow: auto;
  padding: 30px;
  background-color: ${props => props.theme.palette.dashboardBackgroundColor};
`

const LandingPageInnerContainer = styled.div`
  padding: 30px;
  background-color: ${props => props.theme.palette.dashboardInnerBackgroundColor};
`

export const LandingPage = () => {
  const theme = useTheme()

  return (
    <LandingPageContainer theme={theme}>
      <LandingPageInnerContainer theme={theme}>
        <Cards />
        <YDivider height={middleVerticalSpace} />
        <ReportsCard />
      </LandingPageInnerContainer>
    </LandingPageContainer>
  )
}
